import {FreeSpinsModule} from '@gongxigames/framework/slot';
import {GameFreeSpinsRetriggerState} from 'src/freespins/states/GameFreeSpinsRetriggerState';
import {GameFreeSpinsIntroState} from 'src/freespins/states/GameFreeSpinsIntroState';
import {GameFreeSpinsInProgressState} from 'src/freespins/states/GameFreeSpinsInProgressState';
import {GameFreeSpinsBasicState} from 'src/freespins/states/GameFreeSpinsBasicState';

export class GameFreeSpinsModule extends FreeSpinsModule {
    protected setupStates(): void {
        this.addState(new GameFreeSpinsBasicState(this, FreeSpinsModule.BASIC_STATE));
        this.addState(new GameFreeSpinsInProgressState(this, FreeSpinsModule.IN_PROGRESS_STATE));
        this.addState(new GameFreeSpinsIntroState(this, FreeSpinsModule.INTRO_STATE));
        this.addState(new GameFreeSpinsRetriggerState(this, FreeSpinsModule.RETRIGGER_STATE));
        this.gotoState(FreeSpinsModule.BASIC_STATE);
    }
}
